import styled from "styled-components";
export const Wrapper = styled.div `
  background-color: white;
  display: block;
  width: 256px;
`;
